<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2>
        <div style="text-align: right">
          <v-btn @click="$router.replace('/MyQueue')"  color='grey' dark large class="my-queue">My Queue</v-btn>
        </div>
      </v-flex>
      <v-flex xs12 md8 offset-md2>
        <v-flex xs12 md4 left>
          <h1 class="mb-3 text-xs-center greyy">Open Orders</h1>
          <div class="circle">
            <div justify-center align-center v-if="freeSamplesLoading">
              <v-progress-circular
              indeterminate
              color="primary">
              </v-progress-circular>
            </div>
            <div v-else class="pinkk">
              {{total}}
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md4 left>
          <h1 class="mb-3 text-xs-center greyy">Unassigned Orders</h1>
          <div class="circle">
            <div justify-center align-center v-if="freeSamplesLoading">
              <v-progress-circular
              indeterminate
              color="primary">
              </v-progress-circular>
            </div>
            <div v-else class="pinkk">
              {{unAssignedTotal}}
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md4 left>
          <h1 class="mb-3 text-xs-center greyy">Assigned Orders</h1>
          <div class="circle">
            <div justify-center align-center v-if="freeSamplesLoading">
              <v-progress-circular
              indeterminate
              color="primary">
              </v-progress-circular>
            </div>
            <div v-else>
              {{assignedTotal}}
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md12 class="table-responsive">
          <table width="100%" class='text-xs-center greyy'>
            <thead>
              <tr>
                <th width="20%"><v-btn @click="Assign()" :disabled="selected.length === 0" large class="greyy assign-btn">Assign</v-btn></th>
                <th width="20%" class='text-xs-left'>Order Code</th>
                <th width="20%" class='text-xs-left'>Name</th>
                <th width="20%">No. Samples</th>
                <th width="20%" class='text-xs-left'>Date</th>
              </tr>
            </thead>
            <tbody v-if="orders.length">
              <tr v-for="(order, index) in orders" :key="index">
                <td><v-checkbox v-model="selected" :value="order._id" hide-details class="align-center justify-center"></v-checkbox></td>
                <td class='text-xs-left'>{{order.orderCode}}</td>
                <td class='text-xs-left'>{{order.customerID.firstName}} {{order.customerID.lastName}}</td>
                <td>{{order.freeSamples.length}}</td>
                <td class='text-xs-left'>{{ new Date(order.date).getDate() + "/" + (new Date(order.date).getMonth() + 1) + "/" + new Date(order.date).getFullYear() }}</td>
              </tr>
            </tbody>
            <tbody v-else>
                <tr>
                <td colspan="5">
                  <v-layout justify-center align-center mt-5 v-if="freeSamplesLoading">
                    <v-progress-circular
                    indeterminate
                    color="primary">
                    </v-progress-circular>
                  </v-layout>
                  <v-layout justify-center align-center mt-5 v-else>
                    No Records found
                  </v-layout>
                </td>
                </tr>
            </tbody>
          </table>
        </v-flex>
      </v-flex>
    </v-layout>

    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import FreeSampleService from '@/services/FreeSampleService'
import OrderService from '@/services/OrderService'
export default {
  name: 'FreeSamplesNew',
  data () {
    return {
      loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
      orders: [],
      freeSamplesLoading: true,
      popupText: null,
      snackbar: false,
      totalFreeSamples: 0,
      loadingText: 'Loading...',
      selected: [],
      total: 0,
      unAssignedTotal: 0,
      assignedTotal: 0
    }
  },
  mounted () {
    this.getFreeSamples()
  },
  methods: {
    async getFreeSamples () {
      this.freeSamplesLoading = true

      const response = await FreeSampleService.getPendingFreeSamples()

      let orders = response.data.freeSamples

      this.total = orders.length
      var unAssinedOrders = orders.filter(function (order) {
        return order.freeSampleAssignee === undefined || !order.freeSampleAssignee
      })

      this.unAssignedTotal = unAssinedOrders.length
      this.assignedTotal = this.total - this.unAssignedTotal

      this.orders = unAssinedOrders

      if (orders.length === 0) {
        this.loadingText = 'No Free Samples Found.'
      }

      this.freeSamplesLoading = false

      return unAssinedOrders
    },
    async Assign () {
      await OrderService.updateFreeSampleAssignee(this.selected, this.loggedInUser._id)
      for (let index = 0; index < this.unAssignedTotal; index++) {
        const order = this.orders[index]
        if (this.selected.includes(order._id)) {
          this.orders.splice(index, 1)
          this.unAssignedTotal--
          this.assignedTotal++
        }
      }
      this.selected = []
    }
  }
}
</script>
<style scoped>
th, td {
  padding: 10px;
  font-size: 20px;
}
.circle {
  width: 250px;
  height: 250px;
  border: 5px solid #565e6f;
  margin: 0 auto;
  text-align: center;
  line-height: 250px;
  border-radius: 50%;
  font-size: 72px;
  font-weight: bold;
  color: #565e6f;
  padding-top: 0;
}
.md4 {
  width: 33.33%;
}
.pinkk {
  color: #ea4d76;
}
.greyy {
  color: #565e6f;
}
.assign-btn {
  font-size: 20px;
  font-weight: bold;
}
.table-responsive{
  width:100%;
  overflow-x: auto;
}
@media screen and (max-width: 661px) {
  .md4 {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/freeSamples/FreeSamplesNew.vue